<template>
  <div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <component-input
                placeholder="Введите наименование"
                v-model="currFilters.name"
                label="Наименование организации	"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <component-input
                v-model="currFilters.inn"
                label="ИНН организации"
              />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>Принимает ЛРАС</label>
              <select
                class="form-control"
                v-model="currFilters.acceptsPatients"
              >
                <option v-for="item in yesNoList" :value="item.id">
                  {{ item.text }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label>Статус</label>
              <select
                class="form-control"
                v-model="currFilters.employerStatusId"
              >
                <option v-for="item in employerStatuses" :value="item.id">
                  {{ item.text }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer d-flex">
        <button-component class="col-6" @click="apply">
          Применить
        </button-component>
        <button-component class="col-6" kind="secondary" @click="reset">
          Сбросить
        </button-component>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonComponent from "@/common/ui/ButtonComponent";
import ComponentInput from "@/common/components/ComponentInput";
import Constants from "@/common/constants";
import Utils from "../../../common/utils";

export default {
  name: "VacancyFilters",
  components: { ComponentInput, ButtonComponent },
  props: {
    filters: Object,
  },
  data() {
    return {
      currFilters: this.filters,
      yesNoList: Constants.yesNoList,
      employerStatuses: [
        {
          id: 0,
          text: Constants.emptySelectOptionText,
          selected: true,
        },
      ],
    };
  },
  methods: {
    apply() {
      const filters = Object.assign({}, this.currFilters);
      this.$emit("apply", filters);
    },
    reset() {
      this.currFilters = {
        name: "",
        inn: "",
        acceptsPatients: null,
        employerStatusId: 0,
      };
      const filters = Object.assign({}, this.currFilters);
      this.$emit("reset", filters);
    },
    loadDictionaries() {
      Utils.loadSelectOptions("employerStatus", this.employerStatuses);
    },
  },
  created() {
    this.loadDictionaries();
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/theme/default/colors";
.form-group {
  label {
    font-weight: 400 !important;
    color: $gray-dark;
    font-size: 16px;
  }
}

.card-footer {
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}
</style>
